import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Context } from '../shared/services/context.service';

@Injectable({
  providedIn: 'root'
})
export class PdfService {

  constructor(private http: HttpClient) { }

  htmlToPdf(htmlContent) {
    return this.http.post(
      Context.apiUrl + 'devis/generatePDF/Basss/b2d6fc6a375d21e87ba3e1cbe7d93501', 
      // "http://localhost:8080/" + 'devis/generatePDF/Basss/b2d6fc6a375d21e87ba3e1cbe7d93501', 
      htmlContent, 
      {
        headers: new HttpHeaders().set('Content-Type', 'text/html'),
        responseType: 'blob' as 'json'
      }
    );  
  }
}
